import { AutogenModelUnpostedWire, AutogenRowUnpostedWire } from "./autogen/AutogenModelUnpostedWire";

export class ModelUnpostedWire extends AutogenModelUnpostedWire<RowUnpostedWire> {
	constructor() {
		super(RowUnpostedWire);
	}
}

export class RowUnpostedWire extends AutogenRowUnpostedWire {
}